import script from "./AlarmRulesForm.vue?vue&type=script&setup=true&lang=js"
export * from "./AlarmRulesForm.vue?vue&type=script&setup=true&lang=js"

import "./AlarmRulesForm.vue?vue&type=style&index=0&id=80d2c1b0&lang=css"

const __exports__ = script;

export default __exports__